export { getDuplicatedCss, isNarrow, isSmallItem, isShort, isVerticalContainer, shouldAddLegacyPaddingBottom };
import { GALLERY_CONSTS } from 'pro-gallery-lib';
function getDuplicatedCss(options) {
    function getInfoHorizontalPadding(options) {
        if (options.imageInfoType === GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND ||
            options.imageInfoType === GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) {
            return options.textsHorizontalPadding + 30;
        }
        return options.textsHorizontalPadding;
    }
    return {
        paddingBottom: options.textsVerticalPadding + 15 + 'px',
        paddingTop: options.textsVerticalPadding + 15 + 'px',
        paddingRight: getInfoHorizontalPadding(options) + 'px',
        paddingLeft: getInfoHorizontalPadding(options) + 'px',
        boxSizing: 'border-box',
        height: '100%',
    };
}
function isNarrow(props) {
    return props.style.width < 200;
}
function isSmallItem(props) {
    var options = props.options, style = props.style;
    if (GALLERY_CONSTS.isLayout('SLIDESHOW')(options)) {
        return false;
    }
    var isSmallItem;
    var maxWidth = 90;
    var maxHeight = 90;
    if (options.cubeImages && options.cubeType === 'fit') {
        if (style.orientation === 'landscape') {
            // wide image
            isSmallItem = style.width / style.ratio <= maxHeight;
        }
        else {
            // tall image
            isSmallItem = style.height * style.ratio <= maxWidth;
        }
    }
    else {
        isSmallItem = style.width <= maxWidth || style.height <= maxHeight;
    }
    return isSmallItem;
}
function isShort(props) {
    return props.style.height < 150;
}
function isVerticalContainer(props) {
    return props.style.width < props.style.height + 3;
}
function shouldAddLegacyPaddingBottom(props) {
    var options = props.options;
    function allowAnyAction() {
        var options = props.options;
        return options.loveButton || options.allowSocial || options.allowDownload;
    }
    var textsDisplayOnHover = !GALLERY_CONSTS.isLayout('SLIDESHOW')(options) &&
        !GALLERY_CONSTS.isLayout('SLIDER')(options) &&
        !options.hasThumbnails &&
        GALLERY_CONSTS.hasHoverPlacement(options.titlePlacement) &&
        options.hoveringBehaviour !==
            GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW;
    return textsDisplayOnHover &&
        allowAnyAction() &&
        (options.allowTitle || options.allowDescription);
}
//# sourceMappingURL=sharedBetweenMasterAndInfoElement.js.map